module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAAgSURBVDiNY/z///9/BgoAEyWaRwGVAONoNA4HMPDRCABLYgv+ziSDjwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/group.png
// module id = 6bor
// module chunks = 0